import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Modal, Select } from 'antd';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { updateTherapyOccurrenceRequestStatus } from '../../api/therapyOccurrenceRequestsApi';
import { getTherapyOccurrenceRequestStatusLabel } from '../../utils/therapyOccurrenceRequestPresentation';

const statusOptions = [
  { value: 'pending', label: 'Na cekanju' },
  { value: 'sent', label: 'Poslato' },
  { value: 'cancelled', label: 'Otkazano' },
];

const UpdateTherapyOccurrenceRequestStatusModal = ({
  isOpen,
  request,
  onClose,
  onUpdated,
}) => {
  const [status, setStatus] = useState('pending');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setStatus(request?.status || 'pending');
    setNote(request?.note || '');
    setLoading(false);
    setError('');
  }, [isOpen, request?._id, request?.status, request?.note]);

  const handleSave = async () => {
    if (!request?._id) return;
    setLoading(true);
    setError('');

    const { ok, message, data } = await updateTherapyOccurrenceRequestStatus(
      request._id,
      {
        status,
        note: note.trim() || undefined,
      }
    );

    if (!ok) {
      setError(message);
      setLoading(false);
      return;
    }

    await onUpdated?.(data?.request || null);
    onClose();
    setLoading(false);
  };

  return (
    <Modal
      className="therapy_status_modal"
      title="Promeni status zahteva"
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button
          key="save"
          type="primary"
          loading={loading}
          onClick={handleSave}
        >
          Sacuvaj
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 12 }}>
        <strong>Korisnik:</strong>{' '}
        {request?.userName || request?.userEmail || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>LBO:</strong> {request?.userLbo || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Datum rodjenja korisnika:</strong>{' '}
        {request?.userDateOfBirth
          ? dayjs(request.userDateOfBirth).format('DD.MM.YYYY')
          : '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>BZK korisnika:</strong>{' '}
        {request?.userHealthBookletNumber || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Broj telefona korisnika:</strong> {request?.userPhone || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Interna napomena:</strong> {request?.userInternalNote || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Lek:</strong>{' '}
        {Array.isArray(request?.therapyMedications) &&
        request.therapyMedications.length
          ? request.therapyMedications.join(', ')
          : '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Adresa korisnika:</strong> {request?.userAddress || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Aktivnost:</strong>{' '}
        {request?.occurrenceSequenceNumber
          ? `Mesec #${request.occurrenceSequenceNumber}`
          : '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Trenutni status:</strong>{' '}
        {getTherapyOccurrenceRequestStatusLabel(request?.status)}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Nacin slanja / preuzimanja:</strong>{' '}
        {request?.pickupMethod || '-'}
      </div>
      <div style={{ marginBottom: 12 }}>
        <strong>Zeljeni datum dostave:</strong>{' '}
        {request?.requestedDeliveryDate
          ? dayjs(request.requestedDeliveryDate).format('DD.MM.YYYY')
          : '-'}
      </div>
      <Select
        style={{ width: '100%' }}
        value={status}
        onChange={setStatus}
        options={statusOptions}
      />
      <Input.TextArea
        style={{ marginTop: 12 }}
        rows={3}
        placeholder="Napomena (opciono)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
      {!!error && (
        <Alert title={error} type="error" showIcon style={{ marginTop: 16 }} />
      )}
    </Modal>
  );
};

UpdateTherapyOccurrenceRequestStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  request: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onUpdated: PropTypes.func,
};

export default UpdateTherapyOccurrenceRequestStatusModal;
